// extracted by mini-css-extract-plugin
module.exports = {"searchFilterWrapper":"FilterDropdown_searchFilterWrapper__W5VKo"};